/**
 * Human-readable labels for BoM procurement fields.
 * Stored enum values in Firestore / risk engine stay unchanged.
 */
import type { BomCriticality, BomSubstitutability } from '../types/supplyChain';

export const BOM_CRITICALITY_LABELS: Record<BomCriticality, string> = {
  'critical-path': 'On critical path',
  critical: 'Important',
  standard: 'Standard',
};

export const BOM_SUBSTITUTABILITY_LABELS: Record<BomSubstitutability, string> = {
  'sole-source': 'Single vendor',
  limited: 'Few alternatives',
  commodity: 'Standard catalog',
};

export const BOM_CRITICALITY_FIELD_LABEL = 'Schedule impact';
export const BOM_SUBSTITUTABILITY_FIELD_LABEL = 'Vendor alternatives';

export const BOM_CRITICALITY_OPTIONS: readonly BomCriticality[] = [
  'critical-path',
  'critical',
  'standard',
];

export const BOM_SUBSTITUTABILITY_OPTIONS: readonly BomSubstitutability[] = [
  'sole-source',
  'limited',
  'commodity',
];

export function labelBomCriticality(value: BomCriticality): string {
  return BOM_CRITICALITY_LABELS[value] ?? value;
}

export function labelBomSubstitutability(value: BomSubstitutability): string {
  return BOM_SUBSTITUTABILITY_LABELS[value] ?? value;
}
